( function( window, document, $ ) {
    'use strict';

    $( document ).ready( function() {

        // --------------------------------------------------
        // DEFINE FUNCTIONS
        // --------------------------------------------------
        function resizeTwitterAvatars() {
            // Replace 40 x 40 avatar images with 200 x 200
            $( '.ctf-author-avatar img' ).each( function() {
                var oldSrc = this.src;
                var largerImgSrc = oldSrc.replace( '_normal.', '_200x200.' );
                this.src = largerImgSrc;
            } );
        }

        // --------------------------------------------------
        // INIT
        // --------------------------------------------------
        resizeTwitterAvatars();

        if ( typeof Barba !== 'undefined' && typeof Barba.Dispatcher === 'object' ) {
            Barba.Dispatcher.on( 'newPageReady', function() {
                resizeTwitterAvatars();
            } );
        }

    } );

} )( window, document, jQuery );
